import { memo } from 'react';
import { useMedia } from '../../../../media.context';
import {
  Dialog,
  HStack,
  Text,
  Button,
  MediaItem,
  Hint,
} from 'app/pages/request-single-page/components-v4';

type ControlsProps = {
  currentFile?: MediaItem | null;
  previewIndex: number;
  total: number;
  canDelete: boolean;
  onDelete: (id: string) => void;
};

export const Controls = memo(
  ({
    currentFile,
    previewIndex,
    total,
    canDelete,
    onDelete,
  }: ControlsProps) => {
    const { download } = useMedia();

    if (!currentFile) {
      return null;
    }

    const downloadInfo = download.progress[currentFile.id] ?? {
      status: 'idle',
      progress: 0,
    };

    return (
      <Dialog.Panel style={{ maxWidth: 500, marginBottom: 48 }}>
        <HStack padding={16} align="center">
          <Text>
            {previewIndex} из {total}
          </Text>

          <Hint text={currentFile?.name}>
            <Text truncate align="center" style={{ flex: 1 }}>
              {currentFile?.name}
            </Text>
          </Hint>

          <HStack spacing="xs">
            <Button
              mode="accent"
              size="s"
              onClick={() => download.call(currentFile)}
              pending={downloadInfo?.status === 'downloading'}
            >
              Скачать
            </Button>

            {canDelete && (
              <Button
                mode="error"
                size="s"
                onClick={() => onDelete(currentFile.id)}
              >
                Удалить
              </Button>
            )}
          </HStack>
        </HStack>
      </Dialog.Panel>
    );
  }
);
